import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["value", "onChange", "readOnly", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ControlStatus } from '@isyc-react/types';
import { components, InputSelect } from '@isyc-react/form/modules/input/select';
import { useTranslation } from 'react-i18next';
import { nsoncustomer } from "../../../i18n/namespaces";
import clsx from 'clsx';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
const controlOptions = [{
  value: 'NONE',
  label: 'oncustomer.cfv.status.none',
  data: ControlStatus.STATUS_WITHOUT_VALIDATION
}, {
  value: 'VALID',
  label: 'oncustomer.cfv.status.valid',
  data: ControlStatus.STATUS_VALID
}, {
  value: 'INVALID',
  label: 'oncustomer.cfv.status.invalid',
  data: ControlStatus.STATUS_INVALID
}, {
  value: 'INACTIVE',
  label: 'oncustomer.cfv.status.inactive',
  data: ControlStatus.STATUS_INACTIVE
}, {
  value: 'TO_CHECK',
  label: 'oncustomer.cfv.status.toCheck',
  data: ControlStatus.STATUS_TO_CHECK
}];
export const getControlIconClass = status => clsx({
  'mdi-minus text-info': status === ControlStatus.STATUS_WITHOUT_VALIDATION,
  'mdi-check text-success': status === ControlStatus.STATUS_VALID,
  'mdi-close text-danger': status === ControlStatus.STATUS_INVALID,
  'mdi-clock-time-eight-outline text-muted': status === ControlStatus.STATUS_INACTIVE,
  'mdi-alarm-check text-warning': status === ControlStatus.STATUS_TO_CHECK
});
export const ControlStatusView = props => {
  const {
    status,
    label: labelProp
  } = props;
  const {
    t
  } = useTranslation(nsoncustomer.common);
  const label = React.useMemo(() => {
    var _controlOptions$find;
    return labelProp !== null && labelProp !== void 0 ? labelProp : (_controlOptions$find = controlOptions.find(o => o.data === status)) === null || _controlOptions$find === void 0 ? void 0 : _controlOptions$find.label;
  }, [status, labelProp]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: clsx('control-status-view', {
      'status-none': status === ControlStatus.STATUS_WITHOUT_VALIDATION,
      'status-valid': status === ControlStatus.STATUS_VALID,
      'status-invalid': status === ControlStatus.STATUS_INVALID,
      'status-inactive': status === ControlStatus.STATUS_INACTIVE,
      'status-to-check': status === ControlStatus.STATUS_TO_CHECK
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('mdi me-2', getControlIconClass(status))
  }), label && /*#__PURE__*/React.createElement(React.Fragment, null, t(label))));
};
export const ControlSelectOption = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    t
  } = useTranslation(nsoncustomer.common);
  return /*#__PURE__*/React.createElement(components.Option, rest, /*#__PURE__*/React.createElement("i", {
    className: clsx('mdi me-2', getControlIconClass(props.data.data), {
      'text-white': props.isSelected
    })
  }), t(props.data.label));
};
export const ControlSelectSingleValue = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(components.SingleValue, rest, props.data.data !== undefined && /*#__PURE__*/React.createElement(ControlStatusView, {
    status: props.data.data,
    label: props.data.label
  }));
};
export const InputControl = props => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      value,
      onChange,
      readOnly,
      disabled
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded3);
  const selected = React.useMemo(() => {
    var _controlOptions$find2;
    return (_controlOptions$find2 = controlOptions.find(option => option.data == value.status)) !== null && _controlOptions$find2 !== void 0 ? _controlOptions$find2 : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputSelect, _extends({
    value: selected,
    onChange: c => {
      onChange && onChange(_objectSpread(_objectSpread({}, value), {}, {
        status: c && c.data ? c.data : ControlStatus.STATUS_WITHOUT_VALIDATION
      }));
    },
    options: controlOptions,
    isClearable: (value === null || value === void 0 ? void 0 : value.status) !== ControlStatus.STATUS_WITHOUT_VALIDATION,
    isSearchable: false,
    components: {
      Option: ControlSelectOption,
      SingleValue: ControlSelectSingleValue
    }
  }, rest)));
};